import { DemandeIntervention } from '@/models/DemandeIntervention';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import dayjs from 'dayjs';

export interface SuiviDemandeInterventionState {
    demandesIntervention: DemandeIntervention[];

    tableHeader: TableHeader[];

    page: number;
    count: number;
    nbOfPages: number;
    scroll: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    filterSite: Array<number>;
    siteIds: number[];

    filterStatus: Array<string>;
    filterDemandeInterventionId: string;
    filterMine: boolean;
    filterCreatedDateFrom: string;
    filterCreatedDateTo: string;

    isLoading: boolean;
    error?: Error;
    success: boolean;

    attachment: any;
    attachmentType: string;
    isAttachmentLoading: boolean;

    isExportXlsLoading: boolean;
}

export const initialState: SuiviDemandeInterventionState = {
    demandesIntervention: [],

    tableHeader: [
        {
            label: 'intervention.request.id',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '12%',
        },
        {
            label: 'intervention.request.object',
            sortData: 'libelle',
            sortStatus: SortType.NONE,
            width: '25%',
        },
        {
            label: 'intervention.request.site',
            sortData: 'adresseSiteLibelle',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        },
        {
            label: 'intervention.request.equipement',
            sortData: 'equipement',
            sortStatus: SortType.INACTIVE,
            width: '20%',
        },
        {
            label: 'intervention.request.datecreation',
            sortData: 'creationDate',
            sortStatus: SortType.DESC,
            width: '8%',
        },
        {
            label: 'intervention.request.delais',
            sortData: 'delai',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        },
        {
            label: 'intervention.request.status',
            sortData: 'statut',
            sortStatus: SortType.NONE,
            width: '10%',
            regleCle: 'suiviDemandeIntervention.statuts',
        },
        {
            label: 'intervention.request.pdf',
            sortData: 'pdfExist',
            sortStatus: SortType.INACTIVE,
            regleCle: 'suiviDemandeIntervention.rapport',
            width: '5%',
        },
    ],

    page: 0,
    count: 0,
    nbOfPages: 0,
    scroll: 0,

    sort: {
        sortData: 'creationDate',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    siteIds: [],
    filterStatus: [],
    filterDemandeInterventionId: '',
    filterMine: false,
    filterCreatedDateFrom: dayjs().add(-1,'y' ).format('YYYY-MM-DD'),
    filterCreatedDateTo: dayjs().format('YYYY-MM-DD'),

    isLoading: false,
    success: false,

    attachment: '',
    attachmentType: '',
    isAttachmentLoading: false,

    isExportXlsLoading: false,
};

export const state: SuiviDemandeInterventionState = {
    ...initialState,
};
